/* eslint-disable */
export default {
    invitation: "Uitnodiging",
    inbox_invitation_description_text: "Wanneer je op '>' klikt, ga je naar je persoonlijke gegevens en daarna naar het programma. Elk onderdeel van het programma is voorzien van een instructie en tijdsindicatie. Je kunt tussen de onderdelen door pauzeren.",
    inbox_complete_before: "Afronden voor",
    inbox_invitation: "Uitnodiging",
    inbox_organisation: "Organisatie",
    inbox_start: "Naar overzicht",
    inbox_no_messages_for_participant: "Er zijn geen berichten aanwezig",
    inbox_could_not_process_your_request: "Kan je verzoek niet verwerken",
    inbox_page_title: "Inbox"
};
